import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css';
import { AlSection, AlOtherRow } from 'PatientCareCenter/Note/AL';


class AlOther extends React.Component {

    add() {
        this.props.addAlRow(this.props.noteId, 'MLOTHER', 'XLOE', 'XLOENO', 'XLOEXLNO', this.props.xlno, 'NEW_XLOENO', (this.props.assistVisible && !this.props.isLicensed));
    }

    render() {
        return (
            <AlSection
                id='al_other'
                name='Other'
                timeRequired={false}
                timeVisible={false}
                onAdd={() => this.add()}
            >
                {this.props.others.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>Activity</span>
                        <span className={styles.col2_wide_header}>Description</span>
                        <span className={styles.col3_narrow_header}>Time</span>
                        <span className={styles.col4_header}>Performed</span>
                        {this.props.assistVisible &&
                            <span className={styles.col5_header}>Assistant</span>
                        }
                    </div>
                }
                {Object.keys(this.props.others)
                    .map(key => {
                        const result = this.props.others[key];
                        return (
                            <AlOtherRow key={result.XLOENO} id={result.XLOENO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let assistVisible = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;


    return {
        noteId: noteId,
        xlno: xlno,
        others: Object.keys(state.entities.notes.MLOTHER)
            .filter(key => {
                return (state.entities.notes.MLOTHER[key].XLOEXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLOTHER[a].XLOENO - state.entities.notes.MLOTHER[b].XLOENO)
            .map(key => state.entities.notes.MLOTHER[key]),
        assistVisible: assistVisible,
        isLicensed: isLicensed

    };
}

const connectedAlOther = connect(mapStateToProps, mapDispatchToProps)(AlOther);
export { connectedAlOther as AlOther };

